module.exports = __webpack_public_path__ + "img/neko.7bb6bb52.png";